export default __webpack_public_path__ + "static/media/0380.25d519e6.jpg";